export const LICENSE_KEY = process.env.REACT_APP_MUI_KEY;
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const X_API_KEY = process.env.REACT_APP_X_API_KEY_BO_SF;
export const SERVICE_URL = process.env.REACT_APP_BASE_URL;